import React, {Component} from 'react';
import './tableCommande.css';
import {BootstrapTable, TableHeaderColumn} from 'react-bootstrap-table';
import Moment from 'react-moment'
import { NavLink } from 'react-router-dom';
import CommandeValidation from './CommandeValidation';
import TableSkeleton from "../../skeleton/TableSkeleton";
import { CustomPagination } from "../../../modules/Pagination/CustomPagination";


export default class placedOrders extends Component {
  constructor(props) {
    super(props);
    this.state = {};
  }

  orderCreated(cell, row) {
    return (
      <NavLink
        className="over-class linkable"
        style={{ color: "rgba(0, 0, 0, 0.7)" }}
        to={{
          pathname: `/details-commande-admin/${row?.order_code}`,
          state: { order: row },
        }}
      >
        <Moment format="DD/MM/YYYY">{row.order_date}</Moment>
      </NavLink>
    );
  }

  paymentMode = (cell, row) => {
    return (
      <NavLink
        className="over-class linkable"
        style={{ color: "rgba(0, 0, 0, 0.7)" }}
        to={{
          pathname: `/details-commande-admin/${row?.order_code}`,
          state: { order: row },
        }}
      >
        {row.payment_mode.name}
      </NavLink>
    );
  };
  quantity = (cell, row) => {
    return (
      <NavLink
        className="over-class linkable"
        style={{ color: "rgba(0, 0, 0, 0.7)" }}
        to={{
          pathname: `/details-commande-admin/${row?.order_code}`,
          state: { order: row },
        }}
      >
        {row.cart.number_of_items}
      </NavLink>
    );
  };
  shippingMode = (cell, row) => {
    return (
      <NavLink
        className="over-class linkable"
        style={{ color: "rgba(0, 0, 0, 0.7)" }}
        to={{
          pathname: `/details-commande-admin/${row?.order_code}`,
          state: { order: row },
        }}
      >
        {row.delivery.name}
      </NavLink>
    );
  };
  priceOrder = (cell, row) => {
    return (
      <NavLink
        className="over-class linkable"
        style={{ color: "rgba(0, 0, 0, 0.7)" }}
        to={{
          pathname: `/details-commande-admin/${row?.order_code}`,
          state: { order: row },
        }}
      >
        {Intl.NumberFormat("fr-FR").format(parseInt(row.order_total)) + " FCFA"}
      </NavLink>
    );
  };
  supplierOrder = (cell, row) => {
    return (
      <NavLink
        className="over-class linkable"
        style={{ color: "rgba(0, 0, 0, 0.7)" }}
        to={{
          pathname: `/details-commande-admin/${row?.order_code}`,
          state: { order: row },
        }}
      >
        {" "}
        {row?.user?.first_name + " " + row?.user?.last_name}{" "}
      </NavLink>
    );
  };

  orderStatus = (cell, row) => {
    if (row.status === "placed") {
      let status = "En cours de préparation";
      return status;
    }
    if (row.status === "ready") {
      let status = "Prêt à être livrer";
      return status;
    }
    if (row.status === "paid") {
      let status = "Payée";
      return status;
    }
    if (row.status === "shipped") {
      let status = "En cours de livraison";
      return status;
    }
    if (row.status === "delivered") {
      let status = "Livrée";
      return status;
    }
    if (row.status === "canceled") {
      let status = "Annulée";
      return status;
    }
    if (row.status === "returned") {
      let status = "Retournée";
      return status;
    }
    if (row.status === "failed") {
      let status = "Echec de livraison";
      return status;
    }
  };

  statutFormatter = (cell, row) => {
    if (row.status === "created") {
      let status = "Nouveau";
      return (
        <>
          <span
            className="badge linkable badge-secondary bagde-statut-primary"
            data-toggle="modal"
            data-target={`#orderStatus${row?.id}`}
          >
            {status}{" "}
          </span>
          <div
            className="modal fade easypm-modal orderStatus-modal"
            id={`orderStatus${row?.id}`}
            tabIndex="-1"
            aria-labelledby="orderStatusLabel"
            aria-hidden="true"
          >
            <CommandeValidation order={row} />
          </div>
        </>
      );
    }
    if (row.status === "placed") {
      let status = "En cours de préparation";
      return (
        <>
          <span
            className="badge linkable badge-primary bagde-statut-primary"
            data-toggle="modal"
            data-target={`#orderStatus${row?.id}`}
          >
            {status}{" "}
          </span>
          <div
            className="modal fade easypm-modal orderStatus-modal"
            id={`orderStatus${row?.id}`}
            tabIndex="-1"
            aria-labelledby="orderStatusLabel"
            aria-hidden="true"
          >
            <CommandeValidation order={row} />
          </div>
        </>
      );
    }
    if (row.status === "ready") {
      let status = "Prêt à être livrer";
      return (
        <>
          <span
            className="badge linkable badge-warning bagde-statut-warning"
            data-toggle="modal"
            data-target={`#orderStatus${row?.id}`}
          >
            {status}{" "}
          </span>
          <div
            className="modal fade easypm-modal orderStatus-modal"
            id={`orderStatus${row?.id}`}
            tabIndex="-1"
            aria-labelledby="orderStatusLabel"
            aria-hidden="true"
          >
            <CommandeValidation order={row} />
          </div>
        </>
      );
    }
    if (row.status === "shipped") {
      let status = "En cours de livraison";
      return (
        <>
          <span
            className="badge badge-warning linkable bagde-statut-secondary"
            data-toggle="modal"
            data-target={`#orderStatus${row?.id}`}
          >
            {status}{" "}
          </span>
          <div
            className="modal fade easypm-modal orderStatus-modal"
            id={`orderStatus${row?.id}`}
            tabIndex="-1"
            aria-labelledby="orderStatusLabel"
            aria-hidden="true"
          >
            <CommandeValidation order={row} />
          </div>
        </>
      );
    }
    if (row.status === "delivered") {
      let status = "Livrée";
      return (
        <>
          <span
            className="badge linkable badge-success bagde-statut-success"
            data-toggle="modal"
            data-target={`#orderStatus${row?.id}`}
          >
            {status}{" "}
          </span>
          <div
            className="modal fade easypm-modal orderStatus-modal"
            id={`orderStatus${row?.id}`}
            tabIndex="-1"
            aria-labelledby="orderStatusLabel"
            aria-hidden="true"
          >
            <CommandeValidation order={row} />
          </div>
        </>
      );
    }
    if (row.status === "canceled") {
      let status = "Annulée";
      return (
        <>
          <span
            className="badge linkable badge-danger bagde-statut-danger"
            data-toggle="modal"
            data-target={`#orderStatus${row?.id}`}
          >
            {status}{" "}
          </span>
          <div
            className="modal fade easypm-modal orderStatus-modal"
            id={`orderStatus${row?.id}`}
            tabIndex="-1"
            aria-labelledby="orderStatusLabel"
            aria-hidden="true"
          >
            <CommandeValidation order={row} />
          </div>
        </>
      );
    }
    if (row.status === "returned") {
      let status = "Retournée";
      return (
        <>
          <span
            className="badge linkable badge-danger bagde-statut-todanger"
            data-toggle="modal"
            data-target={`#orderStatus${row?.id}`}
          >
            {status}{" "}
          </span>
          <div
            className="modal fade easypm-modal orderStatus-modal"
            id={`orderStatus${row?.id}`}
            tabIndex="-1"
            aria-labelledby="orderStatusLabel"
            aria-hidden="true"
          >
            <CommandeValidation order={row} />
          </div>
        </>
      );
    }
    if (row.status === "failed") {
      let status = "Echec de livraison";
      return (
        <>
          <span
            className="badge linkable badge-danger bagde-statut-danger"
            data-toggle="modal"
            data-target={`#orderStatus${row?.id}`}
          >
            {status}{" "}
          </span>
          <div
            className="modal fade easypm-modal orderStatus-modal"
            id={`orderStatus${row?.id}`}
            tabIndex="-1"
            aria-labelledby="orderStatusLabel"
            aria-hidden="true"
          >
            <CommandeValidation order={row} />
          </div>
        </>
      );
    }
  }

  render() {
    let { isLoading, page, limit, setLimit, setPage, count, setQuery } =
      this.props;
    const renderPaginationPanel = (props) => {
      return (
        <div class="col-md-12">
          <CustomPagination
            page={page}
            perPage={limit}
            nbPages={count}
            onChange={(page, perPage) => {
              window.scrollTo(200, 200);
              setPage(page);
              setLimit(perPage);
            }}
          />
        </div>
      );
    };

    const renderCustomSearchPanel = (props) => {
      return (
        <div className="form-group form-group-sm react-bs-table-search-form input-group input-group-sm">
          <input
            type="search"
            className="form-control"
            placeholder="Recherche"
            onChange={(e) => setQuery(e.target.value)}
          />
          
        </div>
      );
    };
    const options = {
      noDataText: "Aucune commande disponible",
      paginationPanel: renderPaginationPanel,
      sizePerPage: limit,
      searchPanel: renderCustomSearchPanel,
    };
    let headers = [
      { text: "N ° de commande" },
      { text: "Date" },
      { text: "Prix" },
      { text: "Client" },
      { text: "Mode paiement" },
      { text: "Quantité" },
    ];

    return (
      <div className="table-container">
        {!!isLoading && <TableSkeleton headers={headers} />}
        {!isLoading && (
          <BootstrapTable
            className="head-table-custom"
            data={this.props.commandes}
            search={false}
            multiColumnSearch={true}
            striped
            hover
            options={options}
            multiColumnSort={2}
            pagination
            version="4"
          >
            <TableHeaderColumn
              isKey
              dataField="order_code"
              width="150"
              tdStyle={{
                fontWeight: 400,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
                borderTop: "none",
                borderBottom: "none",
                padding: "1rem",
                textAlign: "center",
              }}
              thStyle={{ textAlign: "center", whiteSpace: "normal" }}
              dataFormat={(cell, row) => {
                return (
                  <NavLink
                    className="over-class linkable"
                    style={{ color: "rgba(0, 0, 0, 0.7)" }}
                    to={{
                      pathname: `/details-commande-admin/${row?.order_code}`,
                      state: { order: row },
                    }}
                  >
                    {" "}
                    {cell}{" "}
                  </NavLink>
                );
              }}
              className="th-table-custom"
            >
              N ° de commande
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="order_date"
              className="th-table-custom"
              width="150"
              dataFormat={this.orderCreated}
              thStyle={{ textAlign: "center" }}
              tdStyle={{
                fontWeight: 400,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
                borderTop: "none",
                borderBottom: "none",
                padding: "1rem",
                textAlign: "center",
              }}
            >
              Date
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="order_total"
              className="th-table-custom"
              dataFormat={this.priceOrder}
              width="200"
              thStyle={{ textAlign: "center" }}
              tdStyle={{
                fontWeight: 400,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
                borderTop: "none",
                borderBottom: "none",
                padding: "1rem",
                textAlign: "center",
              }}
            >
              Prix
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="order_total"
              className="th-table-custom"
              dataFormat={this.supplierOrder}
              width="200"
              thStyle={{ textAlign: "center" }}
              tdStyle={{
                fontWeight: 400,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
                borderTop: "none",
                borderBottom: "none",
                padding: "1rem",
                textAlign: "center",
              }}
            >
              Client
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="payment_mode"
              className="th-table-custom"
              dataFormat={this.paymentMode}
              width="200"
              thStyle={{ textAlign: "center" }}
              tdStyle={{
                fontWeight: 400,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
                borderTop: "none",
                borderBottom: "none",
                padding: "1rem",
                textAlign: "center",
                whiteSpace: "normal",
                textTransform: "capitalize",
              }}
            >
              Mode paiement
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="number_of_items"
              className="th-table-custom"
              dataFormat={this.quantity}
              width="130"
              thStyle={{ textAlign: "center" }}
              tdStyle={{
                fontWeight: 400,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
                borderTop: "none",
                borderBottom: "none",
                padding: "1rem",
                textAlign: "center",
              }}
            >
              Quantité
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="mode_livraison"
              className="th-table-custom"
              dataFormat={this.shippingMode}
              width="250"
              thStyle={{ textAlign: "center" }}
              tdStyle={{
                fontWeight: 400,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
                borderTop: "none",
                borderBottom: "none",
                padding: "1rem",
                textAlign: "center",
                whiteSpace: "normal",
              }}
            >
              Mode de livraison
            </TableHeaderColumn>
            <TableHeaderColumn
              dataField="status"
              className="th-table-custom"
              dataFormat={this.statutFormatter}
              width="230"
              thStyle={{ textAlign: "center" }}
              tdStyle={{
                fontWeight: 400,
                fontSize: 14,
                color: "rgba(0, 0, 0, 0.7)",
                borderTop: "none",
                borderBottom: "none",
                padding: "1rem",
                textAlign: "center",
              }}
            >
              Statut
            </TableHeaderColumn>
          </BootstrapTable>
        )}
      </div>
    );
  }
}